if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }
      show(opener) {
        super.show(opener);
        this.initSwiper();
        this.showActiveMedia();
      }
      initSwiper() {
        const sliderEl = this.querySelector('.swiper-product-modal');
        if (!sliderEl) return;

        if (product_modal_swiper) {
          product_modal_swiper.update();
          return;
        }

        const options = this.getAttribute('data-slider-options');
        if (!options) return;

        const config = JSON.parse(options);

        product_modal_swiper = new Swiper(sliderEl, config);
      }


  showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      if (!mediaId) return;

      const activeMedia = this.querySelector(
        `.swiper-slide[data-media-id="${mediaId}"]`
      );

      if (!activeMedia) {
        console.warn('Active media not found:', mediaId);
        return;
      }

      activeMedia.classList.add('active');

      if (product_modal_swiper) {
        const slideIndex = parseInt(activeMedia.dataset.slideIndex, 10);
        product_modal_swiper.slideTo(slideIndex, 0);
      }

      const deferredMedia = activeMedia.querySelector('deferred-media');
      if (!deferredMedia) return;

      const template = deferredMedia.querySelector('template');
      if (template && deferredMedia.loadContent) {
        deferredMedia.loadContent();
      }
    }

    }
  );
}
